module.exports = __webpack_public_path__ + "static/media/oh.48209931.svg";